
<app-generic-grid #grid
                  (rowToActivate)="activate($event)">
</app-generic-grid>
